import { Box, Button, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";

type ValidateSignatureModalProps = {
  open: boolean;
  onClose: () => void;
};

const optionButtonStyle = {
  textTransform: "none",
  borderRadius: 2,
  minHeight: 68,
  border: "1px solid rgba(1,77,223,0.16)",
  backgroundColor: "rgba(1,77,223,0.035)",
  padding: "10px 16px",
  color: "#17254B",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(0,217,255,0.09)",
    borderColor: "rgba(1,77,223,0.34)",
    boxShadow: "none",
  },
  "&:focus-visible": {
    outline: "3px solid rgba(0,217,255,0.68)",
    outlineOffset: 2,
  },
};

export const ValidateSignatureModal = ({
  open,
  onClose,
}: ValidateSignatureModalProps) => {
  return (
    <Modal open={open} handleClose={onClose} size="xs">
      <ModalHeader
        text={
          <Box
            sx={{
              width: "100%",
              px: { xs: 2.5, sm: 4 },
              pt: 0.5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                display: "grid",
                placeItems: "center",
                borderRadius: "50%",
                backgroundColor: "rgba(1,77,223,0.09)",
                mb: 1,
              }}
            >
              <VerifiedUserRoundedIcon
                aria-hidden="true"
                sx={{ color: "#014DDF", fontSize: 32 }}
              />
            </Box>
            <Typography
              sx={{
                display: "block",
                textAlign: "center",
                fontSize: { xs: 22, sm: 24 },
                lineHeight: 1.2,
                fontWeight: 700,
                color: "#1c2640",
              }}
            >
              Validar mi certificado
            </Typography>
            <Typography
              sx={{
                display: "block",
                mt: 1,
                fontSize: 13,
                lineHeight: 1.5,
                color: "#5f6c8f",
              }}
            >
              Elige dónde verificar la firma.
            </Typography>
          </Box>
        }
        onCancel={onClose}
      />
      <ModalBody dividers={false}>
        <Box sx={{ px: { xs: 0, sm: 1 }, pb: 1.5 }}>
          <Button
            component="a"
            href="https://watana.pe/validar"
            target="_blank"
            rel="noopener noreferrer"
            fullWidth
            variant="contained"
            sx={optionButtonStyle}
          >
            <Box
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "32px minmax(0, 1fr) 20px",
                alignItems: "center",
                columnGap: 1.5,
              }}
            >
              <img src="./icons/validar-firma-watana.png" alt="Watana" width={28} />
              <Box sx={{ textAlign: "left" }}>
                <Typography sx={{ display: "block", fontSize: 15, fontWeight: 700, color: "#1c2640" }}>
                  Watana
                </Typography>
                <Typography sx={{ display: "block", fontSize: 12, lineHeight: 1.35, color: "#65708f" }}>
                  Firma digital
                </Typography>
              </Box>
              <OpenInNewIcon aria-hidden="true" sx={{ fontSize: 18, color: "#33476f" }} />
            </Box>
          </Button>

          <Button
            component="a"
            href="https://apps.firmaperu.gob.pe/web/validador.xhtml"
            target="_blank"
            rel="noopener noreferrer"
            fullWidth
            variant="contained"
            sx={{ ...optionButtonStyle, mt: 1.5 }}
          >
            <Box
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "32px minmax(0, 1fr) 20px",
                alignItems: "center",
                columnGap: 1.5,
              }}
            >
              <img
                src="./icons/validar-firma-gobpe.png"
                alt="Gob.pe"
                width={28}
                style={{ borderRadius: 6 }}
              />
              <Box sx={{ textAlign: "left" }}>
                <Typography sx={{ display: "block", fontSize: 15, fontWeight: 700, color: "#1c2640" }}>
                  Gob.pe
                </Typography>
                <Typography sx={{ display: "block", fontSize: 12, lineHeight: 1.35, color: "#65708f" }}>
                  Validador oficial
                </Typography>
              </Box>
              <OpenInNewIcon aria-hidden="true" sx={{ fontSize: 18, color: "#33476f" }} />
            </Box>
          </Button>

          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Button
              variant="text"
              onClick={onClose}
              sx={{ minHeight: 44, textTransform: "none", color: "#0A229C", fontWeight: 600 }}
            >
              Ahora no
            </Button>
          </Box>
        </Box>
      </ModalBody>
    </Modal>
  );
};
